<!--
 * @Author: M.D.
 * @Date: 2019-12-09 10:24:26
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div id="index">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  created() {},
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
#index {
  height: 100%;
  width: 100%;
}

.main {
  background: bg-color-f1;

  .bShadow-5 {
    box-shadow: 0px 0px 20px 0px rgba(255, 122, 0, 0.15) !important;
  }
}
</style>
